import { cancelWalkThrough } from "api/credit-fetchers";
import { Button } from "../ui/Button";
import { useMutation, useQueryClient } from "react-query";

function FinanceTourContentComponent(props) {
    const queryClient = useQueryClient();
    const { currentStep, steps } = props;
    const isLastStep = currentStep === steps.length - 1;
    const content = steps[currentStep].content;
    const { mutateAsync: handleCancelWalkThrough, isLoading: isCancelingWalkThroughLoading } =
        useMutation({
            mutationFn: () => cancelWalkThrough(),
            onSettled: () => {
                queryClient.invalidateQueries({ queryKey: ["fetchUserProfile"] });
            },
        });
    return (
        <div className="w-full bg-white rounded-lg">
            {typeof content === "function"
                ? content({ ...props, someOtherStuff: "Custom Text" })
                : content}
            <div
                style={{ borderTop: "1px solid #E7E9FB" }}
                className="flex items-center justify-between p-4"
            >
                <p className="text-base font-medium whitespace-nowrap text-secondary-40">
                    {currentStep + 1} of {steps.length}
                </p>
                <Button
                    onClick={async () => {
                        if (isLastStep) {
                            await handleCancelWalkThrough();
                            props.setIsOpen(false);
                        } else {
                            props.setCurrentStep((s) => s + 1);
                        }
                    }}
                    disabled={isCancelingWalkThroughLoading}
                    size="sm"
                >
                    Next
                </Button>
            </div>
        </div>
    );
}

export const TourContentChild = ({ title, content }) => {
    return (
        <div className="p-4">
            <h3 className="text-2xl font-semibold">{title}</h3>
            <p className="text-sm text-secondary-40">
                {typeof content === "function" ? content() : content}
            </p>
        </div>
    );
};

export default FinanceTourContentComponent;
